import axios from 'axios';
import { TIME_OUT, BASE_URL } from './config';

/**
 * Axios instance for anonymous (unauthenticated) API calls.
 * Does NOT inject an Authorization header and does NOT redirect on 401.
 */
const anonymousInstance = axios.create({
  baseURL: BASE_URL,
  timeout: TIME_OUT,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  }
});

anonymousInstance.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }
  },
  (err) => {
    // Surface the server's error message when available (ABP UserFriendlyException pattern)
    const serverMessage =
      err.response?.data?.error?.message || err.response?.data?.message || err.message || 'An unexpected error occurred.';
    return Promise.reject(new Error(serverMessage));
  }
);

export default anonymousInstance;
